"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookLogo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("../SVGBox");
var RegularSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6656 21.75H3.32625C2.73168 21.75 2.25 21.268 2.25 20.6737V3.32624C2.25 2.73175 2.73175 2.25 3.32625 2.25H20.6738C21.2682 2.25 21.75 2.73175 21.75 3.32624V20.6737C21.75 21.2681 21.2681 21.75 20.6738 21.75H15.7047V14.1985H18.2394L18.6189 11.2556H15.7047V9.3767C15.7047 8.52465 15.9413 7.944 17.1631 7.944L18.7215 7.94332V5.31113C18.452 5.27527 17.5269 5.19514 16.4507 5.19514C14.2038 5.19514 12.6656 6.56662 12.6656 9.08524V11.2556H10.1244V14.1985H12.6656V21.75Z", fill: "black" }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.8874 29H4.435C3.64224 29 3 28.3574 3 27.5649V4.43499C3 3.64234 3.64234 3 4.435 3H27.5651C28.3576 3 29 3.64234 29 4.43499V27.5649C29 28.3575 28.3575 29 27.5651 29H20.9396V18.9314H24.3192L24.8252 15.0074H20.9396V12.5023C20.9396 11.3662 21.2551 10.592 22.8842 10.592L24.962 10.5911V7.08151C24.6027 7.03369 23.3693 6.92685 21.9343 6.92685C18.9385 6.92685 16.8874 8.75549 16.8874 12.1137V15.0074H13.4992V18.9314H16.8874V29Z", fill: "black" }, void 0) }), void 0));
};
var FacebookLogo = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.FacebookLogo = FacebookLogo;
//# sourceMappingURL=FacebookLogo.js.map